<template>
  <card-dialog
    v-model="modalVisible"
    max-width="700px"
    title="Change attributes for selected songs"
  >
    <v-card-text
      class="pa-6"
    >
      <div class="font-weight-bold mb-2">
        Set attributes for {{ selectedLibraryFiles.length }} selected songs
      </div>
      <validation-observer ref="validation">
        <div
          v-for="attribute in attributes"
          :key="attribute.id"
        >
          <v-select
            v-model="selectedAttributes[attribute.id]"
            :label="attribute.title"
            :items="attribute.values"
            item-text="value"
            item-value="id"
            deletable-chips
            outlined
            clearable
            multiple
          />
        </div>
      </validation-observer>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="primary"
          :loading="submitting"
          @click="submit()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import LibraryFiles from '@/services/LibraryFiles'

export default {
  name: 'EditFilesAttributesDialog',
  components: { CardDialog },
  props: {
    selectedLibraryFiles: {
      type: Array,
      default: () => ([])
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedAttributes: {},
      submitting: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    },
    attributes() {
      return this.$store.state.attributes.data
    }
  },
  methods: {
    async submit() {
      if (!(await this.$refs.validation.validate())) {
        return
      }

      await this.save()
    },
    async save() {
      try {
        this.submitting = true

        await LibraryFiles.updateAttributes(this.selectedLibraryFiles.map(f => f.id), Object.values(this.selectedAttributes).flat())

        this.$emit('updated')

        this.$store.dispatch('alert', {
          text: 'Song attributes successfully updated',
          color: 'success'
        })

        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There were some errors changing attributes',
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
